import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HamburgerMenu.module.scss';
import cn from 'classnames';
const HamburgerMenu = ({ onClick, isActive }) => {
    return (_jsxs("div", Object.assign({ onClick: onClick, className: cn(styles.element, isActive && styles['isActive']) }, { children: [_jsx("span", { className: cn(styles.line, styles.line1) }), _jsx("span", { className: cn(styles.line, styles.line2) }), _jsx("span", { className: cn(styles.line, styles.line3) })] })));
};
export default HamburgerMenu;
